<template>
  <el-tabs type="card" v-model="activeName">
    <el-tab-pane label="Firmware" name="first">
      <OTA v-if="first"></OTA>
    </el-tab-pane>
    <el-tab-pane label="BLE firmware" name="second">
      <Bluetooth v-if="second"></Bluetooth>
    </el-tab-pane>
    <el-tab-pane label="System tones" name="third">
      <DeviceAudioVersion v-if="third"></DeviceAudioVersion>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import OTA from '../ota/OTA'
  import Bluetooth from '../bluetooth/Bluetooth'
  import DeviceAudioVersion from '../deviceAudio/DeviceAudioVersion'
  export default {
    name: 'index',
    components:{
      OTA,DeviceAudioVersion,Bluetooth
    },
    data(){
      return{
        activeName:'first',
        first: true,
        second:false,
        third:false
      }
    },
    methods:{
    },
    watch:{
      activeName:function (newData, oldData) {
        this[oldData]=false
        this[newData]=true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/versionManage/index.vue